/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemProps,
  ListItemText,
  ListItemTextProps,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: theme.spacing(10.5),
    paddingTop: 17.5,
    paddingBottom: 17.4,
    alignItems: 'flex-start',
  },
}));

export type EditableListItemProps = {
  ListItemTextProps?: ListItemTextProps;
  emptyValueText?: string;
  label?: ReactNode;
  value?: unknown;

  renderValue?: (props: ReactNode | string) => ReactNode;
  renderLabel?: (props: ReactNode) => ReactNode;
} & ListItemProps;

export default function EditableListItemSkeleton({
  label,
  value,
  renderValue = (value) => value as ReactNode,
  renderLabel = (labelValue) => labelValue,
  emptyValueText = 'Lorem ipsum dolar sit',
  ListItemTextProps,
  divider = true,
  ContainerComponent,
}: EditableListItemProps): JSX.Element {
  const primaryValue = renderLabel(label);
  const secondaryText = value ? value : emptyValueText;
  const secondaryValue = renderValue(secondaryText);

  const classes = useStyles();
  return (
    <>
      <ListItem
        className={classes.root}
        ContainerComponent={ContainerComponent}
        divider={divider}
        disableGutters={true}
        data-testid="editable-list-item-skeleton"
      >
        <ListItemAvatar>
          <Skeleton variant="rect">
            <Avatar />
          </Skeleton>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Skeleton>
              <Typography variant="inherit" component="span">
                {primaryValue}
              </Typography>
            </Skeleton>
          }
          secondary={
            <Skeleton>
              <Typography variant="inherit" component="span">
                {secondaryValue}
              </Typography>
            </Skeleton>
          }
          primaryTypographyProps={{
            noWrap: true,
          }}
          secondaryTypographyProps={{
            noWrap: true,
          }}
          {...ListItemTextProps}
        />
      </ListItem>
    </>
  );
}
